import { ProviderFragment } from '../../../generated/graphql'
import { Provider } from '../common/Provider'
import { providerProperties } from '../../../provider/provider-properties'

export function createMapFragmentToProvider(temperatureValues?: number[]) {
  return (provider: ProviderFragment): Provider => {
    const MatchingProvider = providerProperties[provider.type].providerClass

    if (!MatchingProvider) {
      throw new Error(`Unable to map '${provider.type}' to provider`)
    }

    return new MatchingProvider(provider, temperatureValues)
  }
}
